<template>
  <v-container fluid fill-height class="loginOverlay ma-auto">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="5" md="3">
        <LoginForm :portalName="$t('customer.portal.title')"  :loginFunction="loginFunc" />
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import AuthStoreMixin from "@/helpers/mixins/AuthStoreMixin";
import LoginForm from "@/components/Forms/LoginForm.vue";

export default {
  name: "LoginPage",
  mixins: [AuthStoreMixin],
  components: {
    LoginForm,
  },

  data() {
    return {

    };
  },

  mounted() { },

  methods: {
    loginFunc({ username, password }) {
      return this.loginCustomer({ username: username, password });
    }
  },

  computed: {},

  watch: {},
};
</script>


<style lang="scss"></style>